import { Remove } from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  FormControl,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const Dropdown = ({
  options,
  submittedAnswer,
  isFrom,
  handleQuesAnswer,
  checkBoxOption = [],
  setCheckBoxOption = () => {},
  usingQues,
  comment,
  event,
  question,
  hasAttachedDocument,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [newOption, setNewOption] = useState("");
  const [newWeightage, setNewWeightage] = useState("");
  const [commentBox, setCommentBox] = useState("");
  const [attachDocument, setAttachDocument] = useState(null);

  const customOptions = [
    // { option: "Option 1", weightage: 2 },
    // { option: "Option 2", weightage: 3 },
  ];

  useEffect(() => {
    if (checkBoxOption?.length === 0 && !submittedAnswer) {
      if (
        usingQues?.questionType === "ZERO_TO_TEN" ||
        usingQues?.questionType === "LIKERT" ||
        usingQues?.questionType === "SATISFACTION" ||
        usingQues?.questionType === "QUALITY" ||
        usingQues?.questionType === "FREQUENCY" ||
        usingQues?.questionType === "PERFORMANCE" ||
        usingQues?.questionType === "IMPORTANCE" ||
        usingQues?.questionType === "EMOTIONS" ||
        usingQues?.questionType === "TABLE"
      ) {
        setCheckBoxOption(customOptions);
      } else {
        setCheckBoxOption(options || customOptions);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddOption = () => {
    if (newOption.trim() && newWeightage.trim()) {
      setCheckBoxOption([
        ...checkBoxOption,
        { option: newOption.trim(), weight: parseFloat(newWeightage) },
      ]);
      setNewOption("");
      setNewWeightage("");
    }
  };

  const handleRemoveOption = (index) => {
    setCheckBoxOption(checkBoxOption.filter((_, i) => i !== index));
  };

  const handleOptionChange = (item) => {
    setSelectedOption(item);
  };
  const handleChange = (type, value) => {
    if (type === "option") {
      setSelectedOption(value);
    } else if (type === "comment") {
      setCommentBox(value);
    } else if (type === "document") setAttachDocument(value);

    if (isFrom === "taskSection") {
      const obj = {
        value: type === "option" ? value?.option : selectedOption?.option,
        weight: type === "option" ? value?.weight : selectedOption?.weight,
        comment: type === "comment" ? value : commentBox,
        supporting_document:
          type === "document" && value === null ? value : attachDocument,
        document: type === "document" ? value : attachDocument,
        documentMetaData:
          type === "document"
            ? {
                ques_id: question?._id,
                name: value?.name,
                is_supporting_document: true,
                type: value?.type,
              }
            : null,
      };
      handleQuesAnswer({ obj, realQuestion: question });
    }
  };

  useEffect(() => {
    if (submittedAnswer) {
      setSelectedOption({
        option: submittedAnswer?.[0]?.value,
        weight: submittedAnswer?.[0]?.weight,
      });
      setCommentBox(submittedAnswer?.[0]?.comment || "");
      setAttachDocument(submittedAnswer[0]?.supporting_document || null);
    }
  }, []);

  const placeholderSize = {
    inputProps: {
      sx: { fontSize: "14px" }, // Adjust placeholder font size
    },
  };

  const labelSize = {
    style: { fontSize: "14px" }, // Adjust label font size
  };

  return (
    <Box
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      {isFrom === "surveyCreation" ? (
        // Render as Chips for survey creation
        <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
          {checkBoxOption?.length > 0 ? (
            checkBoxOption?.map((item, index) => (
              <Chip
                key={index}
                label={item.option}
                onDelete={() => handleRemoveOption(index)}
              />
            ))
          ) : (
            <Typography>Add some options to the dropdown</Typography>
          )}
        </Box>
      ) : (
        // Render as Dropdown for other sections
        <>
          {
            <FormControl fullWidth style={{ marginTop: "15px" }}>
              <InputLabel
                id="option-label"
                size="small"
                style={{ fontSize: "14px" }}
              >
                {isFrom === "approvalSection"
                  ? "Selected option"
                  : "Select option"}
              </InputLabel>
              <Select
                labelId="option-label"
                value={selectedOption?.option || ""}
                onChange={(event) => {
                  const selected = (checkBoxOption || options)?.find(
                    (item) => item.option === event.target.value
                  );
                  handleChange("option", selected);
                }}
                label={
                  isFrom === "approvalSection"
                    ? "Selected option"
                    : "Select option"
                }
                size="small"
                style={{ pointerEvents: event }}
              >
                {(checkBoxOption || options)?.map((item, index) => (
                  <MenuItem key={index} value={item.option}>
                    {item.option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          }
        </>
      )}

      {isFrom === "surveyCreation" && (
        <Box display="flex" gap={1} mt={2}>
          <TextField
            label="New Option"
            value={newOption}
            onChange={(e) => setNewOption(e.target.value)}
            size="small"
          />
          <TextField
            label="Weightage"
            type="number"
            value={newWeightage}
            onChange={(e) => setNewWeightage(e.target.value)}
            size="small"
          />
          <Button
            variant="contained"
            onClick={handleAddOption}
            disabled={!newOption || !newWeightage}
            size="small"
          >
            Add Option
          </Button>
        </Box>
      )}

      {comment && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <AdvancedInputField
            data={commentBox}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) => handleChange(name, value)}
          />
        </Box>
      )}

      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleChange}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default Dropdown;

// {comment && (
//   <Box style={{ pointerEvents: event, marginTop: "10px" }}>
//     <TextField
//       fullWidth
//       id="comment"
//       label="Contributor's comment"
//       variant="outlined"
//       multiline
//       minRows={2}
//       placeholder="Contributor's comment"
//       style={{ marginTop: "10px" }}
//       value={commentBox}
//       // defaultValue={}
//       onChange={(e) => setCommentBox(e.target.value)}
//     />
//   </Box>
// )}
